import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { ProductDataProvider } from "../../data-provider/product.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { Plan } from "../../models/plan.model";

let LicenseInfoDialogComponent = {
    selector: "vcPromoCodeDialog",
    templateUrl: "/angular/components/product/promo-code-dialog.component.html",
    bindings: {},
    controller: class PromoCodeDialog {
        private userDataProvider: UserDataProvider;
        private productDataProvider: ProductDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private signedInUser;
        private activeCampaign;

        public saving;
        public plan: Plan;
        public selectedInterval: string;
        public plans: any;
        public promotion: any = {};

        public selectedCoreLevel: number = 0;
        public selectedProLevel: number = 0;

        constructor(
            $window: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ProductDataProvider: ProductDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider,
            UserDataProvider: UserDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.userDataProvider = UserDataProvider;
            this.productDataProvider = ProductDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.signedInUser = this.userDataProvider.getActiveUser();
            this.dialog = DialogUtils;
            this.toast = ToastUtils;

            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();

            this.subscriptionDataProvider
                .planInfo(this.activeCampaign.cpid)
                .then((plan) => {
                    this.plan = plan;
                    this.selectedInterval = this.plan.cpinterval;
                    this.subscriptionDataProvider
                        .getPlans(this.activeCampaign.campaignid, null)
                        .then((plans) => {
                            this.plans = plans;

                            let coreMonthlyPlans: any[] = [];
                            let coreYearlyPlans: any[] = [];
                            let proMonthlyPlans: any[] = [];
                            let proYearlyPlans: any[] = [];
                            angular.forEach(
                                plans,
                                (plan: any, index: number) => {
                                    if (plan.cpname.startsWith("Core")) {
                                        if (plan.cpinterval == "Monthly") {
                                            coreMonthlyPlans.push(plan);
                                        } else {
                                            coreYearlyPlans.push(plan);
                                        }

                                        if (plan.cpid == this.plan.cpid) {
                                            this.selectedCoreLevel = index;
                                        }
                                    } else if (plan.cpname.startsWith("Pro")) {
                                        if (plan.cpinterval == "Monthly") {
                                            proMonthlyPlans.push(plan);
                                        } else {
                                            proYearlyPlans.push(plan);
                                        }

                                        if (plan.cpid == this.plan.cpid) {
                                            this.selectedProLevel = index;
                                        }
                                    }
                                }
                            );

                            this.plans = {
                                core: {
                                    monthly: { plans: coreMonthlyPlans },
                                    yearly: { plans: coreYearlyPlans },
                                },
                                pro: {
                                    monthly: { plans: proMonthlyPlans },
                                    yearly: { plans: proYearlyPlans },
                                },
                            };
                        });
                });
        }

        confirm(): void {
            this.saving = true;
            this.subscriptionDataProvider
                .applyPromoCode(this.promotion.id)
                .then(
                    () => {
                        this.saving = false;
                        this.dialog.hide();
                    },
                    (error) => {
                        this.saving = false;
                        this.toast.error(error);
                    }
                );
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("product")
    .component(LicenseInfoDialogComponent.selector, LicenseInfoDialogComponent);
